
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';

import { sharedState } from '../../../../../../framework/state';
import { getResource } from '../../../../../../framework/client/resource';
import { SalesInvoiceRow } from '../../../../../../../common/application/model/SalesInvoiceRow';
import { getDatabaseOptions } from '../../../../../../framework/service/options';
import { InvoiceRowType } from '../../../../../../../common/application/model/enums/InvoiceRowType';
import { VehicleContract } from '../../../../../../../common/application/model/VehicleContract';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import { VendorContract } from '../../../../../../../common/application/model/VendorContract';
import { dateToDbDateString } from '../../../../../../../common/framework/util/convert';

@Component({})
export default class ViewSalesInvoiceRow extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.SALES_INVOICE_ROW;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as SalesInvoiceRow,
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
        vehicleContract: {} as VehicleContract,
        vendorContract: {} as VendorContract,
        startDate: '',
        endDate: '',
        invoiceRowType: '',
    };

    // Functions
    async mounted() {
        this.local.row = (await getResource<SalesInvoiceRow>(this.resourceType, this.id))!!;
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);

        this.local.startDate = dateToDbDateString(
            DateTime.fromJSDate(new Date(this.local.row.startDate), { zone: 'UTC' }).toJSDate(),
        );
        this.local.endDate = dateToDbDateString(
            DateTime.fromJSDate(new Date(this.local.row.endDate), { zone: 'UTC' }).toJSDate(),
        );

        if (this.local.row.vehicleContractId) {
            this.local.vehicleContract = (await getResource<VehicleContract>(
                ApplicationResource.VEHICLE_CONTRACT,
                this.local.row.vehicleContractId,
            ))!!;
        }

        if (this.local.row.vendorContractId) {
            this.local.vendorContract = (await getResource<VendorContract>(
                ApplicationResource.VENDOR_CONTRACT,
                this.local.row.vendorContractId,
            ))!!;
        }

        if (this.local.row.invoiceRowType) {
            this.local.invoiceRowType = this.getInvoiceRowType(
                this.local.row.invoiceRowType,
                this.local.invoiceRowTypeOptions,
            );
        }
    }

    private getInvoiceRowType(
        invoiceRowType: InvoiceRowType,
        options: { id: string | undefined; label: string }[],
    ): string {
        const option = options.find((option) => option.id === invoiceRowType);
        return option ? option.label : '-';
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/sales-invoice-row/${this.local.row.id}/edit`);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }
}
